<template>
  <Page class="page-container--scrollable-table">
    <PageContent>
      <UnitsContext>
        <DomainVerificationContext>
          <MembersTabs>
            <RouterView />
          </MembersTabs>
        </DomainVerificationContext>
      </UnitsContext>
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import DomainVerificationContext from '@/components/deepadmin/domain-verifications/DomainVerificationContext.vue'
import MembersTabs from '@/components/deepadmin/members/MembersTabs.vue'
import UnitsContext from '@/components/deepadmin/units/UnitsContext.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

const { permissions } = useAuthorizationContext()

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.users.title',
  },
})

usePageAccess(
  computed(
    () => !permissions.canReadOrganizationMenu || !permissions.canManageUsers,
  ),
)
</script>
